import { filters } from "@/filters";

export const filtersMixin = {
  data() {
    return {
      filters: filters,
    };
  },
};
